export default __webpack_public_path__ + "3ec27f4973d0a85943fb20272a0004a4.svg";